export default "__VITE_ASSET__f90c1ef5__"